import { observer } from 'mobx-react-lite';
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Container } from '@mui/material';
import { Box } from '@livable/saas-react-components';
import AllocationsTab from './AllocationsTab';
import AllocationsTabs from './AllocationsTabs';
const AllocationsPage = observer(() => {
  const location = useLocation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AllocationsTabs, null), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, location.pathname === '/allocations' && /*#__PURE__*/React.createElement(AllocationsTab, null), /*#__PURE__*/React.createElement(Outlet, null))));
});
export default AllocationsPage;